import React from 'react'
import FlagForm from './FeatureFlagForm/FeatureFlagForm'
import FlagsTable from './FeatureFlagsTable/FeatureFlagsTable'

const FeatureFlags = (props: {
  history: {
    goBack: () => void
  }
  match: { params: { id: string } }
}) => {
  const {
    match: {
      params: { id },
    },
  } = props

  const FeatureFlagsContent = id ? FlagForm : FlagsTable

  return <FeatureFlagsContent {...props} />
}

export default FeatureFlags
